/**
 * DashboardQuickActions Component
 *
 * Quick action buttons for common tasks
 */

import React from 'react';
import { Typography, Button, Space, Tag, Skeleton } from 'antd';
import {
  MdAdd,
  MdSearch,
  MdPendingActions,
  MdAssessment,
  MdPerson
} from 'react-icons/md';
import { useNavigate } from 'react-router-dom';


const { Title, Text } = Typography;

interface DashboardQuickActionsProps {
  followupsCount?: number;
  followupsLoading?: boolean;
  canViewFollowup?: boolean;
}

export const DashboardQuickActions: React.FC<DashboardQuickActionsProps> = ({
  followupsCount = 0,
  followupsLoading = false,
  canViewFollowup = false,
}) => {
  const navigate = useNavigate();

  return (
    <div className="shadow-none rounded-lg bg-white p-4">
      <Title level={5} className="!mb-1">
        Quick Actions
      </Title>
      <Text type="secondary" className="text-sm">
        Common tasks and shortcuts
      </Text>

      <Space direction="vertical" className="w-full mt-4" size="middle">
        <Button
          type="primary"
          icon={<MdAdd size={18} />}
          block
          onClick={() => navigate('/quotes/new')}
          className="!flex !items-center !justify-start"
        >
          Create New Quote
        </Button>

        <Button
          icon={<MdSearch size={18} />}
          block
          onClick={() => navigate('/quotes')}
          className="!flex !items-center !justify-start"
        >
          Search Quotes
        </Button>

        {/* Show follow-up button only if user has view_followup permission */}
        {canViewFollowup && (
          <Button
            icon={<MdPendingActions size={18} />}
            block
            onClick={() => navigate('/quotes?status=pending')}
            className="!flex !items-center !justify-between"
          >
            <span>Pending Follow-ups</span>
            {followupsLoading ? (
              <Skeleton.Avatar active size="small" shape="circle" />
            ) : followupsCount > 0 ? (
              <Tag color="warning" className="!m-0">
                {followupsCount}
              </Tag>
            ) : null}
          </Button>
        )}


        <Button
          icon={<MdAssessment size={18} />}
          block
          onClick={() => navigate('/analytics')}
          className="!flex !items-center !justify-start"
        >
          View Analytics
        </Button>



        <Button
          icon={<MdPerson size={18} />}
          block
          onClick={() => navigate('/installers')}
          className="!flex !items-center !justify-start"
        >
          Manage Installers
        </Button>

      </Space>
    </div>
  );
};

export default DashboardQuickActions;
